import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

export default class GameHUDHeader extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,num) {
    super(scene);

    this.lblRound = ABCyaPhaser.Images.addImage(20,10,UIAssetKeys._Label_Round, this).setOrigin(0);

    this.lblRoundNum = ABCyaPhaser.Text.addText(this.lblRound.x + this.lblRound.width + 10,7,gameData.fontSizes.sm,0xffffff, FontKeys._asapmedium, num, this).setOrigin(0);

    this.indicatorContainer = this.scene.add.container();
    this.indicators = [];
    let item = null;
    let itemWidth = 0;
    let curx = 0;
    for (let i = 0; i < 10; i++) {
      item = ABCyaPhaser.Images.addImage(curx,0,UIAssetKeys._RoundIndictor_off, this.indicatorContainer);
      itemWidth = item.getBounds().width;
      curx += itemWidth + 5;
      this.indicators.push(item);
    }
    this.indicatorContainer.x = this.scene.scale.width / 2 - this.indicatorContainer.getBounds().width / 2 + itemWidth / 2;
    this.indicatorContainer.y = 20;
    this.add(this.indicatorContainer);

    this.lblInstruct = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Instruct_Questions, this).setOrigin(0);
    this.lblInstruct.x = this.scene.scale.width / 2 - this.lblInstruct.width / 2;
    this.lblInstruct.y = this.scene.scale.height - this.lblInstruct.height - 10;
  }

  turnOnIndicator (i) {
    this.indicators[i].setFrame(UIAssetKeys._RoundIndictor_on);
  }
}